import React from "react";

function ErrorAlertContent({ message, traceId }) {
    return <>
        <p>{message}</p>
        <p className="text-muted" style={{ fontSize: "0.75rem"}}>{traceId}</p>
    </>; 
}

export default ErrorAlertContent;